<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M45.751 32H33.25A1.25 1.25 0 0 0 32 33.25v12.5A1.25 1.25 0 0 0 33.25 47h12.5A1.25 1.25 0 0 0 47 45.751V33.25A1.25 1.25 0 0 0 45.751 32zm-2.383 6.079-4.578 4.375a.633.633 0 0 1-.438.172.617.617 0 0 1-.429-.172l-2.289-2.188a.625.625 0 1 1 .859-.906l1.86 1.774 4.157-3.962a.625.625 0 0 1 .859.906z" style="fill:#517dfb" transform="translate(-29.5 -29.5)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-tutorial03',
});
</script>
